import { render, staticRenderFns } from "./bit.vue?vue&type=template&id=4a6cfdb5"
import script from "./bit.vue?vue&type=script&lang=js"
export * from "./bit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports